(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-drawer"] && !Shopify.designMode) return;
  try {
    function initialiseMoriProductInformationDrawers() {
    document.querySelectorAll('[data-product-information]').forEach((component) => {
      if (component.dataset.initialised === 'true') return;

      const drawer = component.querySelector('[data-product-information-drawer]');
      const drawerTabs = Array.from(component.querySelectorAll('[data-product-drawer-tab]'));
      const section = component.closest('.mori-product-section');
      let returnFocus = null;
      let closeTimer = null;
      let sizeGuideTimer = null;

      if (!drawer) return;

      component.dataset.initialised = 'true';

      const showPanel = (panelName) => {
        component.querySelectorAll('[data-product-drawer-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.productDrawerPanel !== panelName;
        });

        drawerTabs.forEach((tab) => {
          const isSelected = tab.dataset.productDrawerTab === panelName;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });
      };

      const finishClose = () => {
        if (drawer.open) drawer.close();
        drawer.removeAttribute('data-open');
        document.body.classList.remove('mori-product-drawer-open');
        component.querySelectorAll('[data-product-drawer-trigger]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
        if (returnFocus) returnFocus.focus();
      };

      const closeDrawer = () => {
        drawer.dataset.open = 'false';
        window.clearTimeout(closeTimer);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finishClose();
          return;
        }

        closeTimer = window.setTimeout(finishClose, 240);
      };

      const openDrawer = (panelName, trigger) => {
        window.clearTimeout(closeTimer);
        window.clearTimeout(sizeGuideTimer);
        sizeGuideTimer = null;
        returnFocus = trigger;
        showPanel(panelName);
        component.querySelectorAll('[data-product-drawer-trigger]').forEach((drawerTrigger) => {
          drawerTrigger.setAttribute('aria-expanded', drawerTrigger === trigger ? 'true' : 'false');
        });

        const membershipDrawerClose = document.querySelector(
          '.scMembershipDrawerOverlay--open .scMembershipDrawer__close button'
        );
        membershipDrawerClose?.click();

        if (!drawer.open) drawer.showModal();
        document.body.classList.add('mori-product-drawer-open');

        window.requestAnimationFrame(() => {
          drawer.dataset.open = 'true';
          component.querySelector('[data-product-drawer-close]').focus();
        });
      };

      const openSizeGuide = () => {
        const sizeGuideButton = section ? section.querySelector('#sizeBtn') : document.querySelector('#sizeBtn');
        window.clearTimeout(sizeGuideTimer);
        sizeGuideTimer = null;

        if (drawer.open) {
          closeDrawer();
          sizeGuideTimer = window.setTimeout(() => {
            sizeGuideTimer = null;
            sizeGuideButton?.click();
          }, 260);
        } else {
          sizeGuideButton?.click();
        }
      };

      component.addEventListener('click', (event) => {
        const drawerTrigger = event.target.closest('[data-product-drawer-trigger]');
        const drawerTab = event.target.closest('[data-product-drawer-tab]');
        const sizeGuideTrigger = event.target.closest('[data-product-size-guide-trigger]');
        const closeTrigger = event.target.closest('[data-product-drawer-close]');

        if (drawerTrigger) {
          const panelName = drawerTrigger.dataset.productDrawerTrigger;
          openDrawer(panelName, drawerTrigger);
        } else if (drawerTab) {
          showPanel(drawerTab.dataset.productDrawerTab);
        } else if (sizeGuideTrigger) {
          openSizeGuide();
        } else if (closeTrigger) {
          closeDrawer();
        }
      });

      component.addEventListener('keydown', (event) => {
        const currentTab = event.target.closest('[data-product-drawer-tab]');
        if (!currentTab || !drawerTabs.length) return;

        const currentIndex = drawerTabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % drawerTabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + drawerTabs.length) % drawerTabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = drawerTabs.length - 1;
        else return;

        event.preventDefault();
        const nextTab = drawerTabs[nextIndex];
        nextTab.focus();
        showPanel(nextTab.dataset.productDrawerTab);
      });

      drawer.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDrawer();
      });

      drawer.addEventListener('click', (event) => {
        if (event.target !== drawer) return;

        const bounds = drawer.getBoundingClientRect();
        const clickedOutside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (clickedOutside) closeDrawer();
      });

      drawer.addEventListener('close', () => {
        document.body.classList.remove('mori-product-drawer-open');
      });

      drawer.addEventListener('mori:close', closeDrawer);
    });
  }

  function initialiseMoriDrawerCoordination() {
    if (document.documentElement.dataset.moriDrawerCoordinationInitialised === 'true') return;

    document.documentElement.dataset.moriDrawerCoordinationInitialised = 'true';
    document.addEventListener(
      'click',
      (event) => {
        const sleepClubTrigger = event.target.closest(
          '#sleepclub_upsell_panel_new > div:last-child .monthly label'
        );

        if (!sleepClubTrigger) return;

        document.querySelectorAll('[data-product-information-drawer][open]').forEach((drawer) => {
          drawer.dispatchEvent(new CustomEvent('mori:close'));
        });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseMoriProductInformationDrawers);
  } else {
    initialiseMoriProductInformationDrawers();
  }

  initialiseMoriDrawerCoordination();

  document.addEventListener('shopify:section:load', () => {
    initialiseMoriProductInformationDrawers();
    initialiseMoriDrawerCoordination();
  });
  } catch(e) { console.error(e); }
})();

})();
